import React from 'react';
import ReactDOM from 'react-dom/client';
import { configurePdfAssets } from '@ster-co/pdf-viewer';
import { loadRuntimeConfig, setRuntimeConfig } from './config/runtimeConfig';
import './index.css';

// @ster-co/pdf-viewer resolves its bundled pdf.js worker/cmaps/fonts through `import.meta.url`,
// which only lands correctly when the bundler emits the package as its own file. CRA's webpack
// folds it into the main chunk, so we serve the package's assets from /public instead (copied by
// scripts/copy-pdf-assets.js on prestart/prebuild) and point the package at them. Must run before
// the first render, since the viewer reads these URLs lazily on first render.
configurePdfAssets({ baseUrl: '/pdf-viewer-assets/' });

const root = ReactDOM.createRoot(document.getElementById('root'));

const renderRuntimeConfigError = (error) => {
  root.render(
    <div className="loading-container" role="alert">
      <h1>Configuration error</h1>
      <p>{error.message}</p>
    </div>
  );
};

loadRuntimeConfig()
  .then((config) => {
    setRuntimeConfig(config);
    return import('./App');
  })
  .then(({ default: App }) => {
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  })
  .catch(renderRuntimeConfigError);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
